import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyASkpletaqUH-NHlo1avkOAijauzoDf09A",
    authDomain: "coscooter-eu-staging.firebaseapp.com",
    projectId: "coscooter-eu-staging",
    storageBucket: "coscooter-eu-staging.appspot.com",
    messagingSenderId: "485561968577",
    appId: "1:485561968577:web:425a5eef2dfb041824f140",
    measurementId: "G-7GBXJ39TSC",
};

const initializedFirebaseApp = firebase.initializeApp(firebaseConfig);

export const firebaseApp = firebase;

export const firebaseAuth = initializedFirebaseApp.auth();

export const firestore = initializedFirebaseApp.firestore();
